// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myNav {
  margin-bottom: 0;
  background-color: #2d2d30 !important;
  border-color: #3e3e42 !important;
}

.myNav .navbar-brand,
.myNav .nav > li > a {
  color: #cccccc !important;
}

.myNav .nav > li > a:hover {
  color: #ffffff !important;
  background-color: #37373d !important;
}

.navbar-brand-text {
  font-weight: bold;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".myNav {\n  margin-bottom: 0;\n  background-color: #2d2d30 !important;\n  border-color: #3e3e42 !important;\n}\n\n.myNav .navbar-brand,\n.myNav .nav > li > a {\n  color: #cccccc !important;\n}\n\n.myNav .nav > li > a:hover {\n  color: #ffffff !important;\n  background-color: #37373d !important;\n}\n\n.navbar-brand-text {\n  font-weight: bold;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
